import React from "react";
import EvidenceConclusion from "../../EvidenceConclusion";

export default function evidenceConclusionProcessor() {
  const evidenceConclusion = (options) => {
    const { wrapperNode, processNodes, children } = options;
    const content = processNodes(wrapperNode, children);
    return <EvidenceConclusion conclusionData={content} />;
  };

  return { evidenceConclusion };
}
